"use client";

type MatchOverlayProps = {
  kind: "fight" | "finish" | null;
  onComplete?: () => void;
};

export function MatchOverlay({ kind, onComplete }: MatchOverlayProps) {
  if (!kind) return null;

  return (
    <div
      aria-live="assertive"
      className={`match-overlay overlay-${kind}`}
      onAnimationEnd={onComplete}
      role="status"
    >
      {kind === "fight" ? "FIGHT" : "FINISH"}
    </div>
  );
}

